import React from "react";
import { gqlQuery } from "../../../common/lib";
import SortableTable from "../../SortableTable";

export const IndicatorNotesTable = ({ query, vars, columns }) =>
  gqlQuery(query, vars, (res) => <SortableTable columns={columns} items={res?.key_list_item_search ?? []} scrollable />, {
    fetchPolicy: "no-cache"
  });
